module.exports = __webpack_public_path__ + "img/twitter.ce897e80.svg";